import SectionHeader from "components/SectionHeader";
import { currency } from "helpers";
import { ChargeGroup } from "./models";

interface ChargeGroupProps {
    currentUsage: number;
    chargeGroup: ChargeGroup;
}

export default function ChargeGroupView({ chargeGroup, currentUsage }: ChargeGroupProps) {
    const hasPurchasedThisPeriod = currentUsage > 0;

    return (
        <div className="text-sm sm:text-base">
            <SectionHeader>Rates</SectionHeader>
            {hasPurchasedThisPeriod ? (
                <span>Current usage so far: <b>{currentUsage}</b></span>
            ) : (
                <span className="italic text-gray-600">No purchases in the current period</span>
            )}

            <div className="my-3 text-gray-500 font-bold break-words">{chargeGroup.name}</div>
            <div className="-mx-1 overflow-x-auto">
                <table className="w-full min-w-[240px] text-sm">
                    <tbody>
                    {chargeGroup.steps.map((step, index) => (
                        <tr key={index} className={step.isNextStepToUse ? "bg-red-200" : "text-gray-400"}>
                            <td className="text-right px-1 sm:px-2 whitespace-nowrap">{step.min}</td>
                            <td className="w-4 text-center">-</td>
                            <td className="text-left pr-2">
                                {step.max}
                                {step.isNextStepToUse ? " (next)" : ""}
                            </td>
                            <td className="px-1 sm:px-2 py-1 text-right whitespace-nowrap">R {currency(step.rate)}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
